module.exports = __webpack_public_path__ + "img/portrait-055.d13bd29b.jpg";